import { AppThunk } from "store/store";
import {
  setProfileFilterRole,
  setProfileRequestStatus,
  setProfileUpdateStatus,
} from ".";
import { RequestStatus as Status } from "constants/RequestStatus";
import { profileService } from "services/profileService";
import { updateCredentials } from "store/session/thunks";
import { userService } from "services/userService";
import { filterRoleService } from "services/filterRoleService";
import { ActionCreatorWithPayload } from "@reduxjs/toolkit";
import { RequestStatus } from "types";
import { Permission } from "types/FilterRole";

export const getFilterRolePermission =
  (
    id: string,
    providerId: string,
    setStatus: ActionCreatorWithPayload<RequestStatus>,
    setCollection?: ActionCreatorWithPayload<string[]>,
    setCard?: ActionCreatorWithPayload<number | null>
  ): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(setStatus(Status.Idle));
      const { data: rolePermissions } = await filterRoleService.getById(id);
      dispatch(setProfileFilterRole(rolePermissions));
      const collection = rolePermissions.permission.find(
        (provider: Permission) => provider.providerId === Number(providerId)
      )?.filters;
      const cards = rolePermissions.permission.find(
        (provider: Permission) => provider.providerId === Number(providerId)
      )?.filters;
      if (setCollection !== undefined && collection) {
        dispatch(
          setCollection(
            collection.reduce((acc, object) => {
              return acc.concat(object.collection);
            }, [] as string[])
          )
        );
      }
      if (setCard !== undefined && cards) {
        dispatch(setCard(cards[0]?.cardId));
        dispatch(setStatus(Status.Success));
      }
    } catch (error) {
      dispatch(setStatus(Status.Failed));
    }
  };

export const getProfileById =
  (id: number | string): AppThunk =>
  async (dispatch, getState) => {
    try {
      dispatch(setProfileRequestStatus(Status.Loading));
      const { data: profile } = await profileService.getById(id);
      const { data: user } = await userService.getById(id);
      const credentials = getState().session.credentials;
      const updatedCredentials = {
        ...credentials,
        user,
        profile,
      };
      dispatch(updateCredentials(updatedCredentials));
      dispatch(setProfileRequestStatus(Status.Success));
    } catch (error) {
      dispatch(setProfileRequestStatus(Status.Failed));
    }
  };

export const updateProfile =
  (id: string, body: any): AppThunk =>
  async (dispatch, getState) => {
    try {
      dispatch(setProfileUpdateStatus(Status.Loading));
      const { data: profile } = await profileService.update(id, body);
      const { data: user } = await userService.update(id, body);
      dispatch(setProfileUpdateStatus(Status.Success));
      const credentials = getState().session.credentials;
      const updatedCredentials = {
        ...credentials,
        user,
        profile,
      };
      dispatch(updateCredentials(updatedCredentials));
    } catch (error) {
      dispatch(setProfileUpdateStatus(Status.Failed));
    }
  };
